import Vue from 'vue';
import Vuex from 'vuex';
import defaults from './../Pipeline/_defaults';
import VuexPersistence from 'vuex-persist';
import SaveState from './savestate.js';

Vue.use(Vuex);

// Import `getField` and `updateField` for direct editing of state
import { getField, updateField } from 'vuex-map-fields';
import Pipeline from '../Pipeline/Pipeline';

export default new Vuex.Store({
    // todo: remove automatic persistence and persist only when saved.
    // plugins: [new VuexPersistence().plugin],
    state: {
        // a unique identifier for this configuration
        waveformContainerStyle: '',

        // a unique identifier for this configuration
        uniqueId: null,

        // the current step number in the configurator
        step: 0,

        substep: 1,

        availableSubsteps: [0, 0, 3, 0, 2, 0],
        stepsDisabled: [3, 4, 5],
        substepsDisabled: {
            2: [3]
        },

        openingStep: null,

        cropModeActive: false,

        stepQrOpened: false,

        stageScale: 1,

        stageScaleChanged: false,

        loaderPercentage: 0,
        cartBtnClicked: false,

        // the current step number in the configurator
        removedIndex: null,

        removedConfig: null,

        insertIndex: null,

        soundFilesChanged: false,

        // base price for the product
        basePrice: 39,

        globalPresets: {},

        textGuidesDrawn: false,

        // the selected theme (classic/love/family)
        theme: {
            title: '',
            price: null,
            maxRecordings: 1
        },

        // the themes the user can choose from. Price means how much
        // extra the user has to pay to the product base price
        availableThemes: [
            {
                title: 'Classic',
                desc: 'Bei unserer Classic-Variante kannst du als Einzelperson eine persönliche Botschaft aufnehmen und visualisieren.',
                price: 0,
                maxRecordings: 1
            },
            {
                title: 'Love',
                desc: 'Unsere Love-Variante ist für zwei Personen gedacht: Zwei Personen können ihre Botschaft aufnehmen und visualisieren.',
                price: 10,
                maxRecordings: 2
            },
            {
                title: 'Family',
                desc: 'Die Family-Variante ist die Richtige für euch, wenn ihr mehrere Personen seid und alle gemeinsam eine Botschaft aufnehmen wollt. Fünf Stimmenporträts finden hier Platz.',
                price: 20,
                maxRecordings: 5
            },
        ],

        presets: [
            { color: '#390C24', background: '#E1CFCF'},
            { color: '#ADC1CD', background: '#08515A'},
            { color: '#434F4F', background: '#729094'},
            { color: '#A44B5C', background: '#E3D6D6'},
            { color: '#888034', background: '#DFDBDB'},
            { color: '#BAB351', background: '#2C2047'},
            { color: '#C79B4A', background: '#0E3D39'},
            { color: '#C0C0C0', background: '#242E54'},
            { color: '#A79273', background: '#E4E5E0'},
            { color: '#54979A', background: '#ABCECF'},
            { color: '#B7C69D', background: '#50817B'},
            { color: '#31312E', background: '#E1E0D4'},
            { color: '#EBEBC1', background: '#5C5941'},
            { color: '#CFA686', background: '#683531'},
            { color: '#581A1A', background: '#EBE1E0'},
            { color: '#A8C45D', background: '#2E5051'},
            { color: '#BDBBE5', background: '#FFFFFF'},
            { color: '#7C7C7A', background: '#F0E9E1'},
            { color: '#E97D31', background: '#393636'},
            { color: '#65C3A9', background: '#4A4144'},
            { color: '#082F0A', background: '#EFE7DE'},
            { color: '#E5DBCC', background: '#6A0909'},
            { color: '#DDD7CE', background: '#7E5C69'},
            { color: '#B44367', background: '#EFEEEE'},
            { color: '#608E8A', background: '#D7E1DA'},
            { color: '#F7DBDA', background: '#B35E84'},
            { color: '#C0C0C0', background: '#0E3D39'},
            { color: '#A79273', background: '#0E3D39'},
            { color: '#D4C6A1', background: '#FFFFFF'}
        ],

        //------------------------------------------
        // Configured parameters for the image
        //------------------------------------------
        soundFiles: [

        ],

        // is a recording currently in progress
        // !! do not modify this variable directly but
        // !! call the 'startRecorder' or 'stopRecorder' events on the $root element
        // !! instead
        isRecording: false,
        isCountdown: false,
        initUserMedia: false,
        recordingVolume: 0,
        recordingDuration: '0',

        // settings for each wavesurfer wave
        wavesurferWaves: [], // waves generated with wavesurfer.js
        wavesurferPreviews: [], // waves generated with wavesurfer.js
        waveConfigurations: [],

        // settings for the stage
        // - dimensions and orientation
        // - background
        stage: null, // Konvas object
        stageConfiguration: {
            scaling: 1, // when the scaling is bigger the resulting canvas will be bigger
            format: '3-2', // 4-3, 3-2 or panorama
            border: 'free',
            color: '#d4c6a1',
            customTextColor: null,
            borderColor: '#d4c6a1',
            orientation: 'landscape',
            borderColor2: null,
            fontFamily: 'Prata',
            background: {
                type: '',
                image: '',
                text: '',
                textarea: '',
                text_x: 50,
                text_y: 80,
                text_size: 35,
                text_scaleX: 1,
                text_scaleY: 1,
                effect: 'none',
                transform: null,
                color: '#ffffff',
                text_style: false,
                transformer: null,
                text_transparency: 0,
                text_fill: '#000000',
                imageTransformer: null,
                text_fontFamily: 'Prata',
            }
        },

        // texts
        textConfigurations: [

        ],

        // qrcode
        qrcode: {
            use: true,
            voice: true,
            position: 'top-left',
            usePassword: false,
            password: '',
            price: 0,
            instance: null,
        },
        // additional sound file
        extraSound: {
            use: false,
            price: 9.90,
            soundFile: null,
            videoFile: null,
            type: null
        },
        // copy via digital download
        digitalDownload: {
            use: false,
            price: 9.90
        },
        selectedFrameSize: null,
        selectedMaterial: null,
        showFrame: false, // if set to true we leave design mode and display the final image instead
    },
    getters: {
        // this is used for 2-way editing of state through vuex-map-fields
        getField,

        getTotalPrice(state) {
            let price = state.basePrice;

            // when the frame is already selected start calculation
            // with the actual frame size instead of the base price
            if(state.selectedFrameSize && state.selectedFrameSize.price) {
                price = state.selectedFrameSize.price;
            }

            if(state.theme.price) {
                price += state.theme.price
            }

            if(state.qrcode.use && state.qrcode.voice) {
                price += state.qrcode.price;
            }

            if(state.qrcode.use && state.extraSound.use) {
                price += state.extraSound.price;
            }

            if(state.digitalDownload.use) {
                price += state.digitalDownload.price;
            }

            return price;
        }
    },
    mutations: {
        // this is used for 2-way editing of state through vuex-map-fields
        updateField,

        async resetState(state) {
            SaveState.deleteState();
            for (let i = 0; i < state.wavesurferWaves.length; i++) {
                state.wavesurferWaves[i].destroy();
            }

            // clone defaults
            let defaultState = JSON.parse(JSON.stringify(defaults.state));
            delete defaultState.stage;
            // if(theme) {
            //     theme = theme.toLowerCase();
            //     for (let i in state.availableThemes) {
            //         if (state.availableThemes[i].title.toLowerCase() === theme) {
            //             defaultState.theme = state.availableThemes[i];
            //             if(defaultState.step === 0) {
            //                 defaultState.step = 1;
            //             }
            //         }
            //     }
            // }

            // theme should aways be classic
            defaultState.theme = state.availableThemes[0];
            if(defaultState.step === 0) {
                defaultState.step = 1;
            }

            // override state object values with defaults
            state = Object.assign(state, defaultState);

            state.stageConfiguration.fontFamily = defaultState.stageConfiguration.fontFamily;

            state.globalPresets.color = defaultState.stageConfiguration.color;
            state.stageConfiguration.color = defaultState.stageConfiguration.color;
            state.stageConfiguration.borderColor = defaultState.stageConfiguration.color;

            state.globalPresets.backgroundColor = defaultState.stageConfiguration.background.color;

            if (state.globalPresets.barGap) {
                delete state.globalPresets.barGap;
                delete state.globalPresets.barWidth;
            }

            state.stageConfiguration.border = defaultState.stageConfiguration.border;
            state.stageConfiguration.orientation = defaultState.stageConfiguration.orientation;
            state.stageConfiguration.format = defaultState.stageConfiguration.format;

            state.textConfigurations = [];
            // qrcode
            state.qrcode.use = false;
            state.qrcode.voice = false;
            state.qrcode.usePassword = false;
            state.qrcode.position = 'top-left';
            state.qrcode.password = '';

            // additional sound file
            state.extraSound.use = false;
            state.extraSound.soundFile = null;
            state.extraSound.videoFile = null;
            state.extraSound.type = null;

            state.digitalDownload.use = false;
            state.waveConfigurations = [];
            state.wavesurferWaves= [];

            return;
        },

        async loadState(state) {
            // set theme from url parameters
            let url_string = window.location.href;
            let url = new URL(url_string);
            let theme = url.searchParams.get("theme");
            let color = url.searchParams.get("color");
            let borderStyle = url.searchParams.get("borderStyle");
            let waveformStyle = url.searchParams.get("waveformStyle");
            let backgroundColor = url.searchParams.get("backgroundColor");
            let orientation = url.searchParams.get("portraitOrientation");
            // let aspectRatio = url.searchParams.get("portraitAspectRatio");
            let font = url.searchParams.get("portraitFont");
            let presetText = url.searchParams.get("portraitPresetText");

            const savedState = await SaveState.loadState();
            if(savedState !== null) {
                const applyState = savedState;

                applyState.openingStep = savedState.step;
                delete applyState.step;
                delete applyState.stage;
                delete applyState.wavesurferWaves;

                // if(theme) {
                //     theme = theme.toLowerCase();
                //     for (let i in state.availableThemes) {
                //         if (state.availableThemes[i].title.toLowerCase() === theme) {
                //             applyState.theme = state.availableThemes[i];
                //             if(applyState.step === 0) {
                //                 applyState.step = 1;
                //             }
                //         }
                //     }
                // }

                // theme should aways be classic
                applyState.theme = state.availableThemes[0];
                if(applyState.step === 0) {
                    applyState.step = 1;
                }

                state = Object.assign(state, applyState);
            }

            // if(theme) {
            //     theme = theme.toLowerCase();
            //     setTimeout(() => {
            //         for (let i in state.availableThemes) {
            //             if (state.availableThemes[i].title.toLowerCase() === theme) {
            //                 state.theme = state.availableThemes[i];
            //                 if(state.step === 0) {
            //                     state.step = 1;
            //                 }
            //             }
            //         }
            //     }, 500);
            // }

            // theme should aways be classic
            setTimeout(() => {
                state.theme = state.availableThemes[0];
                if(state.step === 0) {
                    state.step = 1;
                }

                // if (font) {
                //     state.stageConfiguration.fontFamily = font.replace('%20', ' ');
                // }

                // if (presetText) {
                //     const defaultConfig = JSON.parse(JSON.stringify(defaults.textConfiguration));
                //     const scale = defaults.textConfiguration.scaleX;
                //     const stageWidth = state.stage.width();
                //     const stageHeight = state.stage.height();
                //     const fontFamily = state.stageConfiguration.fontFamily;

                //     state.textConfigurations.push({
                //         ...defaultConfig,
                //         text: presetText,
                //         label: 'preset text',
                //         scaleX: scale,
                //         scaleY: scale,
                //         y: parseInt(stageHeight * 0.79),
                //         x: (stageWidth / 2),
                //         fontFamily: fontFamily,
                //         fill: state.stageConfiguration.color,
                //     });

                //     Pipeline.runTextPipeline();
                // }
            }, 500);

            // if (color) {
            //     state.globalPresets.color = color.replace('%23', '#');
            //     state.stageConfiguration.color = color.replace('%23', '#');
            //     state.stageConfiguration.borderColor = color.replace('%23', '#');
            // }

            // if (backgroundColor) {
            //     state.globalPresets.backgroundColor = backgroundColor.replace('%23', '#');
            // }

            // if (waveformStyle) {
            //     state.globalPresets.style = waveformStyle;

            //     if (waveformStyle == 'bar' || waveformStyle == 'modern') {
            //         state.globalPresets = {...state.globalPresets, ...JSON.parse(JSON.stringify(defaults.defaultsBarStyle))};
            //     }
            // }

            // if (borderStyle == 'border') {
            //     state.stageConfiguration.border = borderStyle;
            // }

            // if (orientation) {
            //     state.stageConfiguration.orientation = orientation;
            // }

            // if (aspectRatio) {
            //     state.stageConfiguration.format = aspectRatio.replace(':', '-');
            // }
        },

        generateUniqueId(state) {
            // return if a unique id already exists
            let randomStr = Math.random().toString(36).substring(2, 8)
                          + Math.random().toString(36).substring(2, 8);
            state.uniqueId = Date.now() + randomStr;
        },

        saveState(state) {
            return SaveState.saveState(state);
        },

        // add a soundFile to the state
        addSoundFile(state, sound) {
            if (state.removedIndex !== null && state.removedIndex <= (state.soundFiles.length - 1)) {
                state.insertIndex = state.removedIndex;
                state.removedIndex = null;
                state.soundFiles.splice(state.insertIndex, 0, sound);
            } else {
                state.removedIndex = null;
                state.soundFiles.push(sound);
            }
        },

        removeSoundFile(state, idx) {
            state.removedIndex = idx;
            state.removedConfig = JSON.parse(JSON.stringify(state.waveConfigurations[idx]));

            // destroy all waves, if removed item is not the last
            if (state.removedIndex != (state.wavesurferWaves.length-1)) {
                for (let i = 0; i < state.wavesurferWaves.length; i++) {
                    state.wavesurferWaves[i].destroy();
                }
                state.wavesurferWaves.splice(0, state.wavesurferWaves.length);
            } else { // if removed index is last one, we only need to destroy last wave
                state.wavesurferWaves[idx].destroy();
                state.wavesurferWaves.splice(idx, 1);
            }

            state.soundFiles.splice(idx, 1);
            state.recordingDuration = "0";
            state.recordingVolume = 0;
        },

        // add extra soundFile to the state
        setExtraSoundFile(state, sound) {
            if (sound == null) {
                state.extraSound.soundFile = null;
                state.extraSound.use = false;
                return;
            }
            state.extraSound.soundFile = sound;
        },

        // add extra soundFile to the state
        setExtraVideoFile(state, videoObject) {
            if (videoObject == null) {
                state.extraSound.videoFile = null;
                state.extraSound.type = null;
                state.extraSound.use = false;
                return;
            }

            state.extraSound.videoFile = videoObject.video;
            state.extraSound.type = videoObject.type;
        },

        setGlobalWaveStyle(state, style) {
            var waves = JSON.parse(JSON.stringify(state.waveConfigurations));

            waves.forEach((wave, idx) => {
                wave.style = style;

                if (style === 'bar' || style === 'modern') {
                    wave.barWidth = defaults.defaultsBarStyle.barWidth;
                    wave.barGap = defaults.defaultsBarStyle.barGap;
                } else {
                    wave.barWidth = 0;
                    wave.barGap = 0;
                }
            });

            state.waveConfigurations = waves;
        },

        /**
         * Merge the state with the values given in the configuration
         * @param state
         * @param newStateConfig
         */
        mergeState(state, newStateConfig) {
            // reset recordings and current wave configurations
            for (let i = 0; i < state.wavesurferWaves.length; i++) {
                state.wavesurferWaves[i].destroy();
            }

            state.soundFiles.splice(0, state.soundFiles.length)
            state.wavesurferWaves.splice(0, state.wavesurferWaves.length);
            state.waveConfigurations.splice(0, state.waveConfigurations.length);
            state.step = 0;

            // apply theme and set step to step 1
            // if (newStateConfig.theme) {
            //     let theme = newStateConfig.theme.toLowerCase();
            //     for (let i in state.availableThemes) {
            //         if (state.availableThemes[i].title.toLowerCase() === theme) {
            //             state.theme = state.availableThemes[i];
            //             state.step = 1;
            //         }
            //     }
            // }

            // theme should aways be classic
            state.theme = state.availableThemes[0];
            if(state.step === 0) {
                state.step = 1;
            }

            // set styles and colors
            // state.globalPresets.style = newStateConfig.waveformStyle ?? defaults.waveConfiguration.style;

            // if (state.globalPresets.style == 'bar' || state.globalPresets.style == 'modern') {
            //     state.globalPresets = {...state.globalPresets, ...JSON.parse(JSON.stringify(defaults.defaultsBarStyle))};
            // } else {
            //     if (state.globalPresets.barGap) {
            //         delete state.globalPresets.barGap;
            //         delete state.globalPresets.barWidth;
            //     }
            // }

            // state.stageConfiguration.border = newStateConfig.borderStyle && newStateConfig.borderStyle != 'none' ? newStateConfig.borderStyle : defaults.state.stageConfiguration.border;

            // state.globalPresets.color = newStateConfig.color ?? defaults.waveConfiguration.color;
            // state.stageConfiguration.color = newStateConfig.color ?? defaults.waveConfiguration.color;
            // state.stageConfiguration.borderColor = newStateConfig.color ?? defaults.waveConfiguration.color;
            // // state.stageConfiguration.borderColor2 = newStateConfig.backgroundColor ?? defaults.waveConfiguration.backgroundColor;

            // state.globalPresets.backgroundColor = newStateConfig.backgroundColor ?? defaults.waveConfiguration.backgroundColor;

            // state.stageConfiguration.orientation = newStateConfig.portraitOrientation ?? defaults.state.stageConfiguration.orientation;
            // // state.stageConfiguration.format = newStateConfig.portraitAspectRatio ? newStateConfig.portraitAspectRatio.replace(':', '-') : defaults.state.stageConfiguration.format;
            // state.stageConfiguration.fontFamily = newStateConfig.portraitFont ?? defaults.state.stageConfiguration.fontFamily;

            state.textConfigurations = [];
            // if (newStateConfig.portraitPresetText) {
                // const defaultConfig = JSON.parse(JSON.stringify(defaults.textConfiguration));
                // const scale = defaults.textConfiguration.scaleX;
                // const size = Pipeline._getCanvasSize();
                // const stageWidth = size.width;
                // const stageHeight = size.height;
                // const fontFamily = state.stageConfiguration.fontFamily;

                // state.textConfigurations.push({
                    // ...defaultConfig,
                    // text: newStateConfig.portraitPresetText,
                    // label: 'preset text',
                    // scaleX: scale,
                    // scaleY: scale,
                    // y: parseInt(stageHeight * 0.79),
                    // x: (stageWidth / 2),
                    // fontFamily: fontFamily,
                    // fill: state.stageConfiguration.color,
                // });

            // }

            Pipeline.runTextPipeline();
        }
    },

    actions: {
        /**
         * Initializes the configurator:
         *  - load saved state
         *  - generates a unique Id (required for the QR code)
         *  - loads price information from the DOM
         * @param commit
         * @param dispatch
         * @param state
         */
        init({commit, dispatch, state}) {
            commit('loadState');
            commit('generateUniqueId');
        },

    }
});
